import Vue from "vue";
import Vuex from "vuex";
import { accessData } from './modules/access_data';
import { login } from './modules/login';
import { account } from './modules/account';
import { management } from './modules/management';
import { companyData } from './modules/company_data';

import entityConfig from "./modules/entity_config";
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const vuexSessionstorage = new VuexPersistence({
  storage: window.sessionStorage
})

export default new Vuex.Store({
  modules: {
    companyData,
    accessData,
    login,
    entityConfig,
    account,
    management,
  },
  plugins: [vuexSessionstorage.plugin]
});